<template>
  <div>
    <div class="row" v-if="resources.length">
      <div
        class="col-12 col-md-6 col-lg-4"
        v-for="(post, index) in resources"
        :key="index"
      >
        <NewsPost :post="post" />
      </div>
    </div>
    <div class="row justify-content-center" v-if="hasMorePosts">
      <button @click="loadMore()" class="btn btn-primary btn-primary--load">
        <span v-if="is_loading">Loading...</span>
        <span v-else>Load More</span>
      </button>
    </div>
  </div>
</template>

<script>
import ResourcesService from "@/services/ResourcesService";
import NewsPost from "./NewsPost";

export default {
  name: "ResourcesLoadMore",
  components: { NewsPost },
  data() {
    return {
      current_page: 1,
      resources: [],
      is_loading: false,
      current_content_type: window.resources_current_content_type,
      current_category: window.resources_current_category,
      max_num_pages: null
    };
  },
  methods: {
    async loadMore() {
      this.is_loading = true;
      ++this.current_page;
      const response = await ResourcesService.get(
        this.current_page,
        this.current_content_type,
        this.current_category
      );
      let newres = [...this.resources, ...response.data.posts];
      this.resources = newres;
      this.max_num_pages = response.data.max_num_pages;
      this.is_loading = false;
    }
  },
  computed: {
    hasMorePosts() {
      if (this.current_page === this.max_num_pages) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
